import React, { useMemo } from "react";
import PropTypes from "prop-types";

import { connect } from "react-redux";

import { Collapse, Well, Row, Col } from "react-bootstrap";
import Formsy from "formsy-react";

import { orderBy, isEmpty } from "lodash";

import DropdownSearch from "../../common/DropdownSearch";

const DestinationSideFilters = ({
  filters,
  projects,
  customers,
  onChangeFilters,
  onResetFilters,
  onStartMigration,
  saving,
  codes,
  customerId
}) => {
  const generateCustomerOptions = () => {
    let filteredCustomers = customers;
    const gravocCustomerNumbers = [
      "GRAVOCAS01",
      "DCGSOFTWARE",
      "GVCNONPROFIT01"
    ];

    if (customerId) {
      // if source customer is a GraVoc customer, filter destination for GraVoc customers
      const sourceCustomer = customers.find((c) => c._id === customerId);
      if (gravocCustomerNumbers.includes(sourceCustomer.number)) {
        filteredCustomers = customers.filter((c) =>
          gravocCustomerNumbers.includes(c.number)
        );
      }
    }

    const customerOptions = filteredCustomers.map((customer) => ({
      value: customer._id,
      label: customer.name
    }));
    return orderBy(customerOptions, [(option) => option.label.toLowerCase()]);
  };

  const filteredProjects = useMemo(
    () =>
      filters.customer && filters.customer.value
        ? projects.filter(
            (proj) =>
              proj.customer &&
              proj.customer._id === filters.customer.value &&
              proj.project_status &&
              proj.project_status.label === "In Process" &&
              proj.name !== "Personal Time"
          )
        : [],
    [filters.customer, projects]
  );

  const callTypeOptions = useMemo(() => {
    const options = codes
      .filter((code) => code.entity === "Call" && code.field === "type")
      .map((code) => ({ value: code._id, label: code.label }));
    return orderBy(options, "order");
  }, [codes]);

  const startMigrationButtonDisabled = useMemo(
    () => isEmpty(filters.customer) || isEmpty(filters.project) || saving,
    [filters.customer, filters.project, saving]
  );

  return (
    <Collapse in className="filter-container">
      <div>
        <Well>
          <Formsy className="vertical form">
            <div className="fields">
              <DropdownSearch
                name="customer"
                placeholder="Customer *"
                onChange={onChangeFilters}
                value={filters.customer.value}
                data={[...generateCustomerOptions()]}
              />
              <DropdownSearch
                name="project"
                placeholder="Project *"
                onChange={onChangeFilters}
                value={filters.project.value}
                data={filteredProjects.map((project) => ({
                  value: project._id,
                  label: `${project.name} - ${project.project_number}`
                }))}
              />
              <DropdownSearch
                disabled
                required
                name="call_type"
                placeholder="Call Type"
                data={[...callTypeOptions]}
                value={filters.call_type.value}
              />
            </div>
            <Row className="mb-0">
              <Col md={12}>
                <button
                  className="btn btn-warning"
                  disabled={saving}
                  type="button"
                  onClick={onResetFilters}
                >
                  Reset Filters
                </button>
                <input
                  className="btn btn-info"
                  type="button"
                  onClick={onStartMigration}
                  disabled={startMigrationButtonDisabled}
                  value={saving ? "Migrating... " : "Start Migration"}
                />
              </Col>
              <Col md={12}>
                <caption>* Required</caption>
              </Col>
            </Row>
          </Formsy>
        </Well>
      </div>
    </Collapse>
  );
};

DestinationSideFilters.propTypes = {
  filters: PropTypes.object,
  customers: PropTypes.array,
  projects: PropTypes.array,
  onChangeFilters: PropTypes.func,
  onResetFilters: PropTypes.func,
  onStartMigration: PropTypes.func,
  saving: PropTypes.bool,
  codes: PropTypes.array,
  customerId: PropTypes.string
};

DestinationSideFilters.defaultProps = {
  filters: {},
  customers: [],
  projects: [],
  onChangeFilters: () => null,
  onResetFilters: () => null,
  onStartMigration: () => null,
  saving: false,
  codes: [],
  customerId: ""
};

function mapStatesToProps(state) {
  return {
    customers: state.reducers.customers,
    projects: state.reducers.projects,
    codes: state.reducers.codes
  };
}

export default connect(mapStatesToProps, null)(DestinationSideFilters);
